const doc = [({"en":({"js":({"admin":({"photo_qualities":({"select":({"choose_photo_quality":"Choose photo quality"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;